angular.module("avlib").directive('radioTrackBy', function(){
return {
		restrict: "A",
		scope: {
			ngModel: "=",
			ngValue: "=",
			radioTrackBy: "@"
		},
		link: function (scope, element, attrs) {
			if (scope.ngValue
					 && scope.ngModel
					 && scope.ngValue[scope.radioTrackBy] === scope.ngModel[scope.radioTrackBy]){
				scope.ngModel = scope.ngValue;
			}
		}
	};
});
